// ----------------------------------------------------------------------------
// GA Tags
// ----------------------------------------------------------------------------
import $ from 'jquery';


// Add to Cart from Collection Page, PDP
$('.add-to-cart').on('click', function() {
  var collection = $(this).data('product-collection');
  var productSKU = $(this).data('product-sku');

  gtag('event', 'Click.AddToCart', {
    'event_category': 'Click',
    'event_label': 'Collection: ' + collection,
    'value': productSKU
  });
});

// Subscribe to Newsletter
$('.newsletter__submit').on('click', function(){
  gtag('event', 'Click.SubscribeToNewsletter', {
    'event_category': 'Click',
    'event_label': 'SubscribeToNewsletter',
    'value': 'N/A'
  });

  // Facebook pixel track lead
  fbq('track', 'Lead');

});
